import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = 'membership/employee'

const employeesEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchEmployees: builder.query<any, void>({
    query: () => ({
      url: basePath,
      method: 'get',
    }),
    providesTags: ['employees'],
  }),

  createEmployee: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}/create`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['employees'],
  }),

  updateEmployee: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['employees'],
  }),

  deleteEmployee: builder.mutation<any, number>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['employees'],
  }),
})

export default employeesEndpoints
